import { isRecordEmpty } from "../object.js";
export const JSON_SCHEMA_TYPE_NAMES = [
    "array",
    "boolean",
    "integer",
    "null",
    "number",
    "object",
    "string",
];
export const SET_OF_JSON_SCHEMA_TYPE_NAMES = new Set(JSON_SCHEMA_TYPE_NAMES);
export function isJsonSchemaType(type) {
    return SET_OF_JSON_SCHEMA_TYPE_NAMES.has(type);
}
// WARN: Order is important
export const RECORDS_OF_SUB_SCHEMAS = [
    "$defs",
    "definitions",
    "properties",
    "patternProperties",
    "dependencies",
];
export const SET_OF_RECORDS_OF_SUB_SCHEMAS = new Set(RECORDS_OF_SUB_SCHEMAS);
// WARN: Order is important
export const ARRAYS_OF_SUB_SCHEMAS = [
    "items",
    "allOf",
    "oneOf",
    "anyOf",
];
export const SET_OF_ARRAYS_OF_SUB_SCHEMAS = new Set(ARRAYS_OF_SUB_SCHEMAS);
// WARN: Order is important
export const SUB_SCHEMAS = [
    "items",
    "additionalItems",
    "additionalProperties",
    "propertyNames",
    "contains",
    "if",
    "then",
    "else",
    "not",
];
export const SET_OF_SUB_SCHEMAS = new Set(SUB_SCHEMAS);
// WARN: Order is important
export const ALL_SUB_SCHEMA_KEYS = [
    ...RECORDS_OF_SUB_SCHEMAS,
    ...ARRAYS_OF_SUB_SCHEMAS,
    ...SUB_SCHEMAS,
];
export function isSchemaObject(schemaDef) {
    return typeof schemaDef === "object";
}
export function isAllowAnySchema(def) {
    return isSchemaObject(def) ? isRecordEmpty(def) : def === true;
}
//# sourceMappingURL=json-schema.js.map